// extracted by mini-css-extract-plugin
export var callCard = "_nx-0";
export var callMessageButton = "_nx-1";
export var helpIcon = "_nx-3";
export var helpIconContainer = "_nx-4";
export var verticalDivider = "_nx-2";